// extracted by mini-css-extract-plugin
export default {"cta-box":"teaser_cta-box__UTAT3"};